import React from "react";
import { Helmet } from "react-helmet";
import MainImage from "../../assets/MainImage.jpg";
import Footer from "../../components/Footer";
import SecondImage from "../../assets/AboutImage4.jpg";
import Navbar from "../../components/NavLite";
import PastWord from "../../components/PastWord";
import SmallTestimony from "../../components/SmallTestimony";

function Houston() {
  return (
    <section>
<Helmet>
  <title>Houston Web Design for Women Entrepreneurs | Woaom Web Design</title>
  <meta
    name="description"
    content="Woaom Web Design builds custom, SEO-powered websites for women entrepreneurs and female founders in Houston, Texas. Mobile-friendly, conversion-focused, and designed to elevate women-led brands."
  />
  <meta
    name="keywords"
    content="Houston web design for women entrepreneurs, Houston TX female founder websites, Houston women-owned business websites, custom websites Houston Texas, SEO web design for women Houston, Houston startup website design, branding for women entrepreneurs Houston TX, creative agency Houston women-led brands, upscale website design Houston TX, mobile-first websites Houston, professional websites for Houston women in business, strategic web design Houston TX, tailored websites for Houston female founders, Houston digital strategy and branding, elegant website design Houston women entrepreneurs, Houston TX personal brand websites, high-converting websites Houston TX, Houston founder-focused design studio, women in tech Houston web design, Houston conversion-optimized websites, React website design Houston women-owned brands, scalable websites for Houston startups, premium website design for Houston business women, Houston TX creative web design studio, women-led business websites Houston TX, Houston SEO websites for women-owned brands, digital presence for Houston entrepreneurs, Houston professional services website design, Houston Texas custom web development for women founders, elevate your Houston brand online"
  />
</Helmet>


      {/* Hero Section */}
      <div
        className="relative h-auto bg-cover bg-center"
        style={{
          clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
          backgroundImage: `url(${MainImage})`,
          padding: "20px",
          width: "100%",
        }}
      >
        <Navbar />
        <div className="p-10">
          <h2 className="text-3xl font-bold uppercase text-black mb-4 text-center">
            <span className="bg-[#CFF098] italic">
              Houston Web Design & SEO for Women Entrepreneurs
            </span>
          </h2>
        </div>
      </div>

      {/* CTA Section */}
      <div className="mx-auto w-full max-w-7xl px-5 py-6 md:px-10 md:py-10 flex flex-col items-center text-center">
        <p className="text-gray-200 mb-4 text-2xl max-w-2xl">
          Based in Houston? We specialize in helping women entrepreneurs build expert-level websites and implement SEO strategies that grow visibility and revenue.
        </p>
        <a href="https://cal.com/woaomwebdesign/15min">
          <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black">
            BOOK A FREE STRATEGY CALL →
          </button>
        </a>
      </div>




{/* Our Process */}
<div className="mx-auto w-full max-w-7xl flex flex-col items-center text-center mt-20">
  <h2 className="text-3xl font-medium md:text-4xl text-white uppercase">
    Our Process
  </h2>
</div>

{/* Centered Paragraph below heading */}
<p className="mx-auto mt-4 max-w-3xl text-sm text-gray-200 sm:text-base md:mb-12 lg:mb-16 text-center">
  We empower Houston’s women entrepreneurs to build powerful websites and get found with expert SEO strategies.
</p>

<div className="flex flex-col md:flex-row items-stretch gap-8 md:gap-12">
  {/* Text Section */}
  <div className="flex flex-col justify-center w-full md:w-1/2">
    {[
      {
        step: 1,
        title: "Goal Discovery",
        desc: "We learn about your Houston business, audience, and vision to craft a personalized plan.",
      },
      {
        step: 2,
        title: "Custom Web Design",
        desc: "Creating a sleek, user-friendly website designed to convert your ideal clients.",
      },
      {
        step: 3,
        title: "Houston SEO Optimization",
        desc: "Applying local SEO techniques to increase your visibility in Houston searches.",
      },
      {
        step: 4,
        title: "Launch & Support",
        desc: "Launching your site and providing ongoing SEO support to sustain growth.",
      },
    ].map(({ step, title, desc }) => (
      <div key={step} className="mb-8 flex max-w-lg justify-center gap-4 px-6 py-5 text-black">
        <div className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-gray-100">
          <p className="text-sm font-bold sm:text-base">{step}</p>
        </div>
        <div className="ml-4 flex flex-col gap-2">
          <h5 className="text-xl font-medium uppercase text-white">{title}</h5>
          <p className="text-sm text-gray-200">{desc}</p>
        </div>
      </div>
    ))}
  </div>

  {/* Image Section */}
  <div className="w-full md:w-1/2 flex items-stretch">
    <img
      alt="website template for coaches, feminine website template, React website template for service providers, sales page template, course website template, booking website template, Kajabi alternative, custom coded website, React Firebase landing page, website template for wellness brand"
      src={MainImage}
      className="w-full object-cover"
    />
  </div>
</div>





      {/* Past Work & Testimonials */}
      <PastWord />
      <SmallTestimony />

      {/* About Us Section */}
      <div className="mx-auto w-full">
        <div className="grid gap-6 sm:gap-6 md:grid-cols-2">
          <div className="flex flex-col items-start gap-2 md:py-24 md:px-24 max-w-[600px] p-4">
            <div className="flex items-center rounded-md py-1">
              <p className="text-sm uppercase mb-12">ABOUT US</p>
            </div>
            <h4 className="mb-6 text-2xl font-semibold md:text-3xl md:mb-8 uppercase">
              Supporting{" "}
              <span className="italic text-black bg-[#CFF098]">
                Houston Women Entrepreneurs
              </span>{" "}
              With{" "}
              <span className="italic text-black bg-[#CFF098]">
                High-Impact Online Visibility
              </span>
            </h4>
            <p className="text-sm text-white sm:text-xl">
              We help women-owned businesses in Houston show up like leaders online. From premium websites to robust SEO plans, we combine strategy and creativity to drive results. Whether you're a coach, founder, or service provider, we create digital tools that grow your brand and boost your confidence.
              <br />
              <br />
              We bring Houston-savvy insights and a women-first perspective to every project.
            </p>
            <p className="mt-6 mb-6 text-xl italic uppercase">
              Let’s make your online presence as bold as your vision.{" "}
              <span className="italic">You bring the dream. We’ll bring the design.</span>
            </p>

            <div className="flex flex-col gap-4 font-regular sm:flex-row">
              <a
                href="/about"
                className="flex rounded-full items-center gap-4 bg-[#CFF098] px-8 py-2 text-black hover:opacity-60 text-sm"
              >
                <p>LEARN MORE ABOUT US →</p>
              </a>
            </div>
          </div>

          <div className="relative w-full h-[]">
            <img
              src={SecondImage}
              alt="waitlist landing page template, email list builder for coaches, launch waitlist template, build email list before launch, email capture website, prelaunch funnel template, flodesk landing page template, convertkit website template, freebie funnel for service business, list-building website template"
              className="absolute top-0 right-0 w-auto h-full object-cover"
            />
          </div>
        </div>
      </div>

      <Footer />
    </section>
  );
}

export default Houston;
